import {
  FaBed,
  FaBath,
  FaCar,
  FaRulerCombined,
  FaBuilding,
  FaTree,
  FaSwimmingPool,
  FaWarehouse,
  FaCouch,
  FaMoneyBillWave,
} from "react-icons/fa";
import { BiExpand } from "react-icons/bi";
import { MdKitchen, MdBalcony } from "react-icons/md";

const characteristicIcons = {
  dormitorios: FaBed,
  baños: FaBath,
  cochera: FaCar,
  superficie: FaRulerCombined,
  pisos: FaBuilding,
  plantas: FaBuilding,
  patio: FaTree,
  pileta: FaSwimmingPool,
  galpon: FaWarehouse,
  galpón: FaWarehouse,
  cocina: MdKitchen,
  balcon: MdBalcony,
  balcón: MdBalcony,
  ambientes: FaCouch,
  expensas: FaMoneyBillWave,
};

// Icono representativo para una característica (dormitorios, baños, etc.)
// según su clave. Si no hay match usa un ícono genérico.
export function getCharIcon(key) {
  const normalized = String(key || "").toLowerCase();
  for (const [keyword, Icon] of Object.entries(characteristicIcons)) {
    if (normalized.includes(keyword)) return Icon;
  }
  return BiExpand;
}
